













import Vue from 'vue'
import { Order } from './components'
import { IStateOrder, IPayment, IShipping } from '@/models'
import { createNamespacedHelpers } from 'vuex'
import {
    STORE_MODULES,
    MUTATIONS_ORDER,
    ACTIONS_ORDER,
    ROUTES,
    PAYMENT_STATE,
    SHIPPING_STATE,
} from '@/enums'

const { mapState, mapMutations, mapActions } = createNamespacedHelpers(STORE_MODULES.ORDER)

export default Vue.extend({
    name: 'OrderDetails',

    components: { Order },

    props: {
        orderCode: String,
    },

    computed: {
        ...(mapState(['order']) as MapStateToComputed<IStateOrder>),
    },

    async created() {
        try {
            await this.redirectToPaymentIfRequired()
            await this.redirectToShippingIfRequired()
            await this.fetchAndSetOrder(this.orderCode)
        } catch (error) {
            this.$router.replace({ name: ROUTES.START })
        }
    },

    beforeDestroy() {
        this.setOrder()
    },

    methods: {
        ...mapMutations({ setOrder: MUTATIONS_ORDER.SET_ORDER }),
        ...mapActions({
            fetchAndSetOrder: ACTIONS_ORDER.FETCH_AND_SET_ORDER,
            fetchPaymentId: ACTIONS_ORDER.FETCH_PAYMENT_ID,
            fetchPayment: ACTIONS_ORDER.FETCH_PAYMENT,
            fetchShippingId: ACTIONS_ORDER.FETCH_SHIPPING_ID,
            fetchShipping: ACTIONS_ORDER.FETCH_SHIPPING,
        }),

        async redirectToPaymentIfRequired() {
            const paymentId = await this.fetchPaymentId(this.orderCode)

            if (!paymentId) return

            const payment: IPayment = await this.fetchPayment(paymentId)

            switch (payment.state) {
                case PAYMENT_STATE.WAITING:
                    return this.$router.replace({
                        name: ROUTES.ORDER_PAYMENT_STATUS,
                        params: { orderCode: this.orderCode, paymentId },
                    })
                default:
                    return
            }
        },

        async redirectToShippingIfRequired() {
            const shippingId = await this.fetchShippingId(this.orderCode)

            if (!shippingId) return

            const shipping: IShipping = await this.fetchShipping(shippingId)

            switch (shipping.state) {
                case SHIPPING_STATE.WAITING_ACCEPT:
                case SHIPPING_STATE.TO_DELIVERY:
                case SHIPPING_STATE.BEEING_DELIVERED:
                case SHIPPING_STATE.DELIVERED:
                case SHIPPING_STATE.CANCELLED:
                    return this.$router.replace({
                        name: ROUTES.ORDER_SHIPPING_STATUS,
                        params: { orderCode: this.orderCode, shippingId },
                    })
                default:
                    return
            }
        },
    },
})
